import { FormattedMessage } from 'react-intl';

import useCustomizableCopy from '../../../hooks/useCustomizableCopy';
import nfcDistrispotLogo from '../../../static/nike/nfc-logo-distrispot.jpg';
import BackAndHomeNavigationButtons from '../../common/BackAndHomeNavigationButtons';
import BaseView from '../../common/BaseView';
import ViewTitle from '../ViewTitle';

interface HowDoesItWorkPart2ViewProps {
    onNext: () => void;
    onLogout?: () => void;
    onInactivity?: () => void;
}

function HowDoesItWorkPart2View(props: HowDoesItWorkPart2ViewProps) {
    const customizableCopy = useCustomizableCopy();

    const homeNav = <BackAndHomeNavigationButtons onHome={props.onLogout} />;

    return (
        <BaseView
            onInactivity={props.onInactivity}
            navbarItems={homeNav}>
            <div className='d-flex flex-column align-items-center'>
                <ViewTitle>
                    <FormattedMessage
                        id='views.nike.how_does_it_work.HowDoesItWorkPart2Title'
                        description='The title of step two of the how does it work flow for Nike'
                        defaultMessage='How does it work?'
                    />
                </ViewTitle>
                <div className='text-center mt-4 m-xl-1 mb-4 mb-xl-1'>
                    <img
                        className='img-fluid responsive-resize-img'
                        src={nfcDistrispotLogo}
                    />
                </div>
                <h3>
                    <FormattedMessage
                        id='views.nike.how_does_it_work.HowDoesItWorkPart2Subtitle'
                        description='The subtitle of step two of the how does it work flow for Nike'
                        defaultMessage='Step 2'
                    />
                </h3>
                <p className='text-center'>
                    <span className='font-weight-bold'>
                        <FormattedMessage
                            id='views.nike.how_does_it_work.HowDoesItWorkPart2ActionMessage'
                            description='The action message of step one of the how does it work flow for Nike'
                            defaultMessage='Scan at the NFC scan location. Try it now.'
                        />
                    </span>
                    <br />
                    <FormattedMessage
                        id='views.nike.how_does_it_work.HowDoesItWorkPart2AdditionalMessage'
                        description='The additional message of step two of the how does it work flow for Nike'
                        defaultMessage='Keep the badge against the plate until you hear a sound. Not working? Contact {your_manager} for support.'
                        values={customizableCopy}
                    />
                </p>
            </div>
        </BaseView>
    );
}

export default HowDoesItWorkPart2View;
